"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonEmptyArray = void 0;
/**
 * @since 0.5.0
 */
var t = __importStar(require("io-ts"));
var NonEmptyArray_1 = require("fp-ts/lib/NonEmptyArray");
var Array_1 = require("fp-ts/lib/Array");
var pipeable_1 = require("fp-ts/lib/pipeable");
var Either_1 = require("fp-ts/lib/Either");
var Option_1 = require("fp-ts/lib/Option");
/**
 * @since 0.5.0
 */
function nonEmptyArray(codec, name) {
    if (name === void 0) { name = "NonEmptyArray<" + codec.name + ">"; }
    var arr = t.array(codec);
    return new t.Type(name, function (u) { return arr.is(u) && Array_1.isNonEmpty(u); }, function (u, c) {
        return pipeable_1.pipe(arr.validate(u, c), Either_1.chain(function (as) {
            var onea = NonEmptyArray_1.fromArray(as);
            return Option_1.isNone(onea) ? t.failure(u, c) : t.success(onea.value);
        }));
    }, function (nea) { return arr.encode(nea); });
}
exports.nonEmptyArray = nonEmptyArray;
